import { ref } from 'vue'
import axios from 'axios'

export function useAuth() {
  const isLoading = ref(false)
  const errorMessage = ref(null)

  const login = async (email, password) => {
    isLoading.value = true
    errorMessage.value = null

    try {
      const response = await axios.post('/users/login', {
        email,
        password
      })

      const token = response.data.token
      localStorage.setItem('menui-token', token)

      return true // Login OK
    } catch (error) {
      errorMessage.value = error.response?.data?.message || 'Error en login'
      return false
    } finally {
      isLoading.value = false
    }
  }

  const logout = () => {
    localStorage.removeItem('menui-token')
  }

  return {
    login,
    logout,
    isLoading,
    errorMessage
  }
}
